import DomainTypeToken from '@apps/domains/admin/tokens/domain_type'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Type extends React.Component {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    domain: {}
  }

  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, disabled: true },
        { label: 't(Next)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { name: 'type', type: 'radiogroup', options: ['registration','transfer','dns'], format: DomainTypeToken, defaultValue: 'registration' }
          ]
        }
      ]
    }
  }

  _handleChange(domain) {
    this.props.onChange(domain)
    this.setState({ domain })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess({ type }) {
    this.props.onNext({ type })
  }

}

export default Type
